.tooltip {
  z-index: var(--z-tooltip);
  max-width: 288px;
  padding: var(--space-2) var(--space-3);
  border-radius: var(--radius-md);
  background: var(--color-tooltip-bg);
  color: var(--color-tooltip-text);
  font-size: var(--type-body-sm-size);
  line-height: var(--type-body-sm-line);
  letter-spacing: var(--tracking-body);
  box-shadow: var(--shadow-overlay);
  overflow-wrap: anywhere;
  pointer-events: none;
}

